import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import CheckboxCell from '../../../../common/interactive/CheckboxCell'
import CustomSelect from '../../../../common/interactive/CustomSelect'
import FalseInputNumber from '../../../../common/FalseInputNumber'
import InputBoxCurrency from '../../../../common/interactive/InputBoxCurrency'
import PhoneGroup from '../../../../fragments/PhoneGroup'
import ExteriorGroup from '../../../../fragments/ExteriorGroup'
import { getLiabilityPolicyStatusLabel, getPolicyLimtsText, getUmPolicyLimitsAmount } from '../../../../../lib/labels'

import { isManagingAttorney, isPrimaryInsurance } from '../../../../../lib/primaryItemScripts'

import classes from '../SurgicalDrawer.module.css'
import { getUMReducedAmount, searchTabInCaseType } from '../../../../../lib/misc'
import GlobalTooltip from '../../../../common/GlobalTooltip'
import SimpleBoxDisplay from '../../../../common/SimpleBoxDisplay'
import { useUserTabEditPermissionDisabled } from '../../../../../lib/usersPermissions'
import { liabilityFunctions } from '../../../../../lib/liability'
import { ascFunctions } from '../../../../../lib/asc'
import { frontendOptions, shouldShowFieldUpdateLoader } from '../../../../../lib/systemData'

export default function FundsAvailable({currentSurgicalitem, updateHandler, apiCase, preauthSaving = false, preauthCheckboxKey = 0}) { //######################### Surgical Review Team (semantic step_2_*) - rendered as TAB #3 after the visual swap
    const activeCase = useSelector(state => state.case.activeCase)

    const modifyFinalFinancialApprovedPermission = useUserTabEditPermissionDisabled('case_surgeries_edit_final_financial_aprove')

    const [managingAttorney, setManagingAttorney] = useState(null)
    const [primaryUM, setPrimaryUM] = useState(null)

    useEffect(() => {
        setManagingAttorney(isManagingAttorney(activeCase))
        setPrimaryUM(isPrimaryInsurance(activeCase, 'mp_pip_um', 'is_um_primary_insurance'))
    }, [activeCase])  


    const estimateSurgeryRedBorderFlag = currentSurgicalitem.step_2_total_funds_approved ? currentSurgicalitem.step_2_estimate_surgery_value > currentSurgicalitem.step_2_total_funds_approved : false
    const primaryLiability = activeCase?.liabilities?.find((item) => item.is_primary_insurance)
    const primaryUmPolicy = activeCase?.mp_pip_um?.find((item) => item.is_um_primary_insurance)
    const showUmAvailable = primaryUM?.has_um ? 'Available' : 'Not Available'
    const umReducedAmount = getUMReducedAmount(liabilityFunctions.isLiabilityValid(activeCase?.liabilities, 'policy_limit_patient'), primaryUM)

    return <>
        <h3 className={classes.pannel_title}>#3 Surgical Review Team</h3>

        {!searchTabInCaseType(activeCase, 'workers_comp') && <div className={classes.drawer_row}>
            <div className='flex-container'>
                <CheckboxCell key={preauthCheckboxKey} label={'Preauthorization Needed'} checked={!!currentSurgicalitem.step_1_preauthorization_required} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_1_preauthorization_required', type_id: currentSurgicalitem.id}} action={updateHandler} apiDisabled={preauthSaving} showApiLoader={shouldShowFieldUpdateLoader()}/>
                <GlobalTooltip noMargin={true}>
                    Linked to Major Med Surgery department PreAuth Needed
                </GlobalTooltip>
            </div>
        </div>}

        {managingAttorney && managingAttorney.attorney && <div className={classes.drawer_row}>
            <SimpleBoxDisplay label={'Attorney'} value={`${managingAttorney.attorney.first_name} ${managingAttorney.attorney.last_name}`} contact_info={managingAttorney.attorney.contact_information} type={'Attorney'} />
        </div>}
        <div className={classes.drawer_row}>
            <CheckboxCell label={'Surgical Estimate'} action={updateHandler} checked={currentSurgicalitem.step_3_surgical_est_completed} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_3_surgical_est_completed', type_id: currentSurgicalitem.id}}/>
        </div>
        {currentSurgicalitem.step_3_approval == 1 && <div className={classes.drawer_row}>
            <CustomSelect
                label={'Approval Statuses'}
                optionsData={frontendOptions()?.surgeryApprovalStatus}
                action={updateHandler}
                identifier={{folder: 'surgeries', type: apiCase, field: 'step_3_approval_status', type_id: currentSurgicalitem.id}}
                normalSize={true}
                preSelectedValue={currentSurgicalitem.step_3_approval_status}
            />
        </div>}
        {managingAttorney && managingAttorney.case_manager && <div className={classes.drawer_row}>
            <div className={classes.group_container}>
                <div className={classes.group_3}>
                    <FalseInputNumber label={'Case Manager'} value={`${managingAttorney.case_manager?.first_name || ''} ${managingAttorney.case_manager?.last_name || ''}`.trim()}/>                
                </div>
                <div className={classes.group_1}>
                    <PhoneGroup phone={managingAttorney.case_manager?.contact_information?.phone}/>
                </div>
                <div className={classes.group_2}>
                    <ExteriorGroup ext={managingAttorney.case_manager?.contact_information?.phone_ext}/>
                </div>
            </div>
        </div>}

        <div className={`${classes.drawer_row}`}>
            <div className={classes.funds_row_two}>
                <div className={liabilityFunctions.liabilityIsADeviation(activeCase) ? classes.orange_row : ''}>
                    <SimpleBoxDisplay label={'Liability'} value={getLiabilityPolicyStatusLabel(primaryLiability?.liability_status)}/>
                </div>
                <div>
                    <CheckboxCell label={'Verified'} checked={primaryLiability?.verified} isDisabled={true} direction={'reverse'}/>
                </div>
            </div>
        </div>
        <div className={`${classes.drawer_row}`}>
            <div className={classes.funds_row_two}>
                <div>
                    <SimpleBoxDisplay label={'Liability Limit Patient'} value={getPolicyLimtsText(primaryLiability?.policy_limit_patient)}/>
                </div>
                <div className={classes.funds_available_currency_cell}>
                    <InputBoxCurrency label={'Liability Funds Available'} action={updateHandler} currentValue={currentSurgicalitem?.step_2_funds_available} identifier={{folder: 'surgeries', type: apiCase, field: 'step_2_funds_available', type_id: currentSurgicalitem.id}} fullBox={true} />
                </div>
            </div>
        </div>

        <div className={`${classes.drawer_row}`}>
            {primaryUM?.has_um ? (
                <div className={classes.funds_um_stack}>
                    <div className={classes.funds_row_three}>
                        <div>
                            <SimpleBoxDisplay label={'UM'} value={showUmAvailable}/>
                        </div>
                        <div>
                            <CheckboxCell label={'Verified'} checked={primaryUM?.um_verified} direction={'reverse'} isDisabled={true}/>
                        </div>
                        <div>
                            {primaryUM?.um_type === 0 ? <SimpleBoxDisplay label={'UM Type'} value={'Addon'}/> : null}
                            {primaryUM?.um_type === 1 ? <SimpleBoxDisplay label={'UM Type'} value={'Reduced'}/> : null}
                        </div>
                    </div>
                    <div className={classes.funds_row_two}>
                        <div>
                            {primaryUM.um_type === 1 && umReducedAmount != null ? (
                                <div className='flex-container'>
                                    <SimpleBoxDisplay label={'Funds Available'} value={`$${umReducedAmount}`}/>
                                    <GlobalTooltip noMargin={true}>
                                        Amount of UM coverage left after subtracting the at-fault driver’s liability
                                    </GlobalTooltip>
                                </div>
                            ) : null}
                        </div>
                        <div>
                            {primaryUM.um_type === 0 ? (
                                <SimpleBoxDisplay label={'UM Limit Patient'} value={`$${getUmPolicyLimitsAmount(primaryUM.um_policy_limit_patient)}`}/>
                            ) : null}
                        </div>
                    </div>
                </div>
            ) : (
                <SimpleBoxDisplay label={'UM'} value={primaryUmPolicy?.has_um ? 'Available' : 'Not Available'}/>
            )}
        </div>

        <div className={classes.drawer_row}>
            <div className={`${classes.funds_row_two} ${classes.funds_total_available_row}`}>
                <div>
                    <CheckboxCell label={'Financial Approval'} action={updateHandler} checked={!!currentSurgicalitem.step_3_financial_approval} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_3_financial_approval', type_id: currentSurgicalitem.id}}/>
                </div>
                <div>
                    <InputBoxCurrency label={'Total Funds Available'} currentValue={ascFunctions.calculateTotalUMFundsAvailable(activeCase, currentSurgicalitem)} identifier={{folder: 'surgeries', type: apiCase, field: 'step_2_funds_available', type_id: currentSurgicalitem.id}} fullBox={true} isNotModifiable={true}/>
                </div>
            </div>
        </div>
        <div className={`${classes.drawer_row} ${classes.funds_summary_row}`}>
            <div className={classes.funds_summary_half}>
                <InputBoxCurrency label={'Final Financial Approved'} action={updateHandler} currentValue={currentSurgicalitem.step_2_total_funds_approved} identifier={{folder: 'surgeries', type: apiCase, field: 'step_2_total_funds_approved', type_id: currentSurgicalitem.id}} fullBox={true} redBorderFlag={!currentSurgicalitem.step_2_total_funds_approved} hasValueBackground={currentSurgicalitem?.step_2_total_funds_approved ? true : null} isNotModifiable={modifyFinalFinancialApprovedPermission}/>
            </div>
        </div>
        <div className={`${classes.drawer_row} ${classes.funds_summary_row}`}>
            <div className={classes.funds_summary_half}>
                <InputBoxCurrency label={'Estimate surgery value'} action={updateHandler} currentValue={currentSurgicalitem.step_2_estimate_surgery_value} identifier={{folder: 'surgeries', type: apiCase, field: 'step_2_estimate_surgery_value', type_id: currentSurgicalitem.id}} fullBox={true} redBorderFlag={estimateSurgeryRedBorderFlag} isNotModifiable={modifyFinalFinancialApprovedPermission}/>
            </div>
        </div>

    </>
}
